// extracted by mini-css-extract-plugin
export default {"tax-slider":"tax-slider","disable-div":"disable-div","input-ele":"input-ele","hsn-slider":"hsn-slider","hsn-slider-icon":"hsn-slider-icon"};